const keys = {
  cp: "capacity",
  cmx: "capacity_max",
  cmn: "capacity_min",
  cs: "classes",
  d: "description",
  h: "hashcode",
  i: "id",
  lt: "lat",
  lg: "lng",
  nm: "name",
  oi: "oid",
  p: "photo",
  ps: "photos",
  rt: "rating",
  s: "score",
  sp: "sort_points",
  sub: "sub_plan",
  ul: "url",
  vh: "venue_hashcode",
  vi: "venue_id",
  vn: "venue_name",
  id: "is_daily",
  ii: "is_instant",
  im: "is_min",
  ipg: "is_per_guest",
  poa: "is_poa",
  pd: "price_daily",
  pdg: "price_delegate",
  pg: "price_guest",
  ph: "price_hourly",
  pm: "price_min",
  pt: "price_model",
  ppd: "price_per_day",
  pp: "price_poa",
  ar: "owner_avg_response",
  aro: "owner",
  st: "status",
  se: "sub_expired",
  vs: "venue_status",
  vc: "country_code",
  ad: "admin",
  vt: "venue_type",
  stg: "space_type",
  ci: "contact_info",
  ct: "city",
  cts: "city_slug",
  pc: "postcode",
  lk: "limit_lock",
};
const keysOut = {};
Object.keys(keys).forEach((k) => {
  keysOut[keys[k]] = k;
});
const SpaceShapeIn = (shape) => {
  let newSpace = {};
  Object.keys(keys).forEach((k) => {
    newSpace[keys[k]] = shape[k];
  });
  return newSpace;
};

export default SpaceShapeIn;
